import {LIVE_STATUS_CHANGE} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case LIVE_STATUS_CHANGE:
            return action.payload;
        default:
            return state;
    }
};